import React from 'react'
import { useField } from 'formik'
import { VehicleProvider } from '@cbgms/api'
import { FieldName_Provider } from 'app/vehicles/components/UnknownVehicleV2/components/providers/const'
import { usePrimaryVehicleSource } from 'app/vehicles/helpers/use-primary-vehicle-source'
import { MMD } from './providers/MMD'
import { MDM } from './providers/MDM'
import { MMT } from './providers/MMT'

interface IProviderContainerProps {
  slotBottomButtons?: React.ReactNode
}
export const ProviderContainer: React.FC<IProviderContainerProps> = ({ slotBottomButtons }) => {
  const [{ value: provider }] = useField(FieldName_Provider)
  const { isVPOM } = usePrimaryVehicleSource()

  if (isVPOM && provider === VehicleProvider.Mdm) {
    // Only EMDM should use MMD, the type list is build from attributes
    return <MMD slotBottomButtons={slotBottomButtons} />
  }
  if (provider === VehicleProvider.Mdm) {
    return <MDM slotBottomButtons={slotBottomButtons} />
  }
  return <MMT slotBottomButtons={slotBottomButtons} />
}
